import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

const FileHandlePlugin = ({ key, editor, onPaste, onDrop, allowedMimeTypes, }) => {
    return new Plugin({
        key: key || new PluginKey('fileHandler'),
        props: {
            handleDrop(_view, event) {
                var _a;
                if (!onDrop) {
                    return false;
                }
                if (!((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files.length)) {
                    return false;
                }
                const dropPos = _view.posAtCoords({
                    left: event.clientX,
                    top: event.clientY,
                });
                let filesArray = Array.from(event.dataTransfer.files);
                if (allowedMimeTypes) {
                    filesArray = filesArray.filter(file => allowedMimeTypes.includes(file.type));
                }
                if (filesArray.length === 0) {
                    return false;
                }
                event.preventDefault();
                event.stopPropagation();
                onDrop(editor, filesArray, (dropPos === null || dropPos === void 0 ? void 0 : dropPos.pos) || 0);
                return true;
            },
            handlePaste(_view, event) {
                var _a;
                if (!onPaste) {
                    return false;
                }
                if (!((_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.files.length)) {
                    return false;
                }
                let filesArray = Array.from(event.clipboardData.files);
                const htmlContent = event.clipboardData.getData('text/html');
                if (allowedMimeTypes) {
                    filesArray = filesArray.filter(file => allowedMimeTypes.includes(file.type));
                }
                if (filesArray.length === 0) {
                    return false;
                }
                event.preventDefault();
                event.stopPropagation();
                onPaste(editor, filesArray, htmlContent);
                // if there is also file data inside the clipboard html,
                // we won't use the files array and instead get the file url from the html
                // this mostly happens for gifs or webms as they are not copied correctly as a file
                // and will always be transformed into a PNG
                // in this case we will let other extensions handle the incoming html via their inputRules
                if (htmlContent.length > 0) {
                    return false;
                }
                return true;
            },
        },
    });
};

const FileHandler = Extension.create({
    name: 'fileHandler',
    addOptions() {
        return {
            onPaste: undefined,
            onDrop: undefined,
            allowedMimeTypes: undefined,
        };
    },
    addProseMirrorPlugins() {
        return [
            FileHandlePlugin({
                key: new PluginKey(this.name), editor: this.editor, allowedMimeTypes: this.options.allowedMimeTypes, onDrop: this.options.onDrop, onPaste: this.options.onPaste,
            }),
        ];
    },
});

export { FileHandlePlugin, FileHandler, FileHandler as default };
//# sourceMappingURL=index.js.map
